/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import React from 'react';
import './hydration-spinner.css';

const SIZE = 44;
const THICKNESS = 3.6;
const RADIUS = (SIZE - THICKNESS) / 2;
const COLOR = '#033c40';

export default function HydrationSpinner() {
  return (
    <div
      style={{
        width: SIZE,
        height: SIZE,
        animation: 'hydration-spinner-rotate 2s linear infinite',
      }}
    >
      <svg width={SIZE} height={SIZE} viewBox={`0 0 ${SIZE} ${SIZE}`}>
        <circle
          cx={SIZE / 2}
          cy={SIZE / 2}
          r={RADIUS}
          strokeWidth={THICKNESS}
          stroke={COLOR}
          fill="none"
          strokeLinecap="round"
          style={{
            animation: 'hydration-spinner-dash 2s ease-in-out infinite',
          }}
        />
      </svg>
    </div>
  );
}
